import type { Author, HomeCategory, Story } from '../data/content'

export type HomeBoot = {
  hero: string
  hottest: string[]
  categorySpotlights: {
    name: HomeCategory
    href: string
    image: string
    lead: string
    list: string[]
  }[]
  more: string[]
}

export type CmsBoot = {
  stories: Story[]
  authors: Author[]
}

export type TiggBoot = {
  feed: CmsBoot
  home?: HomeBoot
  cmsVersion: number
  /** True when feed.stories is the full card index, with no post bodies. */
  cardsIndexed?: boolean
}

export function getBoot(): TiggBoot | undefined {
  const boot = (globalThis as { __TIGG_BOOT__?: TiggBoot }).__TIGG_BOOT__
  return boot
}

export function setBoot(boot: TiggBoot | undefined) {
  ;(globalThis as { __TIGG_BOOT__?: TiggBoot }).__TIGG_BOOT__ = boot
}
